var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBpmSpecial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 419.823,
    height: 43.08,
    viewBox: "0 0 419.823 43.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_99",
    "data-name": "Rect\\xE1ngulo 99",
    width: 262.694,
    height: 41.454,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_140",
    "data-name": "Rect\\xE1ngulo 140",
    width: 117.48,
    height: 43.08,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_627",
    "data-name": "Grupo 627",
    transform: "translate(-899.006 -6263.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_631",
    "data-name": "Grupo 631",
    transform: "translate(1056.135 6264.902)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_630",
    "data-name": "Grupo 630",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_586",
    "data-name": "Trazado 586",
    d: "M16.145,41.294a22.432,22.432,0,0,1-8.674-1.6A26.615,26.615,0,0,1,0,34.88l1.946-2.232A28.422,28.422,0,0,0,5.237,35.31,18.3,18.3,0,0,0,12.2,38.23a21.212,21.212,0,0,0,4.123.373A13.465,13.465,0,0,0,20.44,38a9.748,9.748,0,0,0,3.207-1.661,7.675,7.675,0,0,0,2.061-2.517,6.9,6.9,0,0,0,.745-3.18v-.113a7.933,7.933,0,0,0-.486-2.864,5.513,5.513,0,0,0-1.776-2.291,13.018,13.018,0,0,0-3.463-1.861A35.98,35.98,0,0,0,15.116,22a38.74,38.74,0,0,1-6.185-1.747A15.23,15.23,0,0,1,4.723,17.9a8.058,8.058,0,0,1-2.375-3.12A10.393,10.393,0,0,1,1.6,10.719V10.6a9.033,9.033,0,0,1,.973-4.151A10.514,10.514,0,0,1,5.267,3.1,12.722,12.722,0,0,1,9.332.869a15.893,15.893,0,0,1,5.152-.8,21.28,21.28,0,0,1,7.53,1.2,22.561,22.561,0,0,1,6.214,3.665L26.337,7.283a18.451,18.451,0,0,0-5.754-3.493A18.384,18.384,0,0,0,14.371,2.76a12.69,12.69,0,0,0-4.036.6A9.939,9.939,0,0,0,7.241,4.992,7.175,7.175,0,0,0,5.267,7.4a6.42,6.42,0,0,0-.688,2.92v.115a8.086,8.086,0,0,0,.488,2.89A5.619,5.619,0,0,0,6.842,15.67a12.619,12.619,0,0,0,3.577,1.921,40.981,40.981,0,0,0,5.84,1.6q6.986,1.434,10.078,4.036a8.706,8.706,0,0,1,3.093,7.015v.115a9.922,9.922,0,0,1-1,4.438,10.366,10.366,0,0,1-2.749,3.465,12.932,12.932,0,0,1-4.18,2.232,17.03,17.03,0,0,1-5.354.8",
    transform: "translate(0 0.046)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_587",
    "data-name": "Trazado 587",
    d: "M25.262.412H39.806a20.664,20.664,0,0,1,6.042.831,14.008,14.008,0,0,1,4.694,2.405,10.909,10.909,0,0,1,3.063,3.835,11.833,11.833,0,0,1,1.088,5.182v.115a11.494,11.494,0,0,1-4.668,9.562,15.1,15.1,0,0,1-4.981,2.405,21.885,21.885,0,0,1-5.984.8H28.241V40.493H25.262ZM39.233,22.857a17.648,17.648,0,0,0,5.1-.69,11.612,11.612,0,0,0,3.921-1.987A9.188,9.188,0,0,0,50.8,17.042a9.054,9.054,0,0,0,.916-4.09v-.117A9.549,9.549,0,0,0,50.829,8.6a8.346,8.346,0,0,0-2.49-3.023A11.539,11.539,0,0,0,44.5,3.737a18.054,18.054,0,0,0-4.924-.631H28.241V22.857Z",
    transform: "translate(16.82 0.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_588",
    "data-name": "Trazado 588",
    d: "M49.941.412H78.455V3.1H52.92v15.86H75.88v2.69H52.92V37.8H78.742v2.692h-28.8Z",
    transform: "translate(33.252 0.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_589",
    "data-name": "Trazado 589",
    d: "M93.55,41.454a19.651,19.651,0,0,1-7.959-1.6,19.443,19.443,0,0,1-6.327-4.381,19.856,19.856,0,0,1-4.151-6.555,21.817,21.817,0,0,1-1.489-8.073v-.115a21.314,21.314,0,0,1,1.518-8.016A21.008,21.008,0,0,1,79.32,6.1,19.4,19.4,0,0,1,93.663,0,23.612,23.612,0,0,1,98.53.46a18.824,18.824,0,0,1,4.036,1.316,21.11,21.11,0,0,1,3.493,2.032,33.676,33.676,0,0,1,3.178,2.605l-2.119,2.176a32.917,32.917,0,0,0-2.749-2.349,17.3,17.3,0,0,0-3.063-1.859,18.064,18.064,0,0,0-3.55-1.231,17.785,17.785,0,0,0-4.151-.46A16.246,16.246,0,0,0,81.554,7.874a17.946,17.946,0,0,0-3.55,5.7,18.983,18.983,0,0,0-1.288,7.041v.115A18.8,18.8,0,0,0,78.034,27.8a18.238,18.238,0,0,0,3.577,5.725,16.6,16.6,0,0,0,5.354,3.836,16.03,16.03,0,0,0,6.7,1.4,16.72,16.72,0,0,0,7.558-1.6,24.26,24.26,0,0,0,6.244-4.638l2,1.946a37.707,37.707,0,0,1-3.292,2.835,20.542,20.542,0,0,1-3.608,2.2,20.2,20.2,0,0,1-4.15,1.431,21.679,21.679,0,0,1-4.868.515",
    transform: "translate(49.02 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_98",
    "data-name": "Rect\\xE1ngulo 98",
    width: 2.977,
    height: 40.081,
    transform: "translate(169.939 0.686)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_590",
    "data-name": "Trazado 590",
    d: "M129.514.24h2.862l18.666,40.368h-3.263l-5.1-11.224H119.036l-5.1,11.224h-3.09Zm11.909,26.453L130.886,3.505,120.293,26.693Z",
    transform: "translate(73.806 0.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_591",
    "data-name": "Trazado 591",
    d: "M141.781.412h2.978V37.8h23.533v2.692H141.781Z",
    transform: "translate(94.402 0.275)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_715",
    "data-name": "Grupo 715",
    transform: "translate(899.006 6263.276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_714",
    "data-name": "Grupo 714",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_720",
    "data-name": "Trazado 720",
    d: "M362.333,14.82a1.094,1.094,0,0,1-1.5.177c-1.287-.971-1-12.3-9.331-12.3-4.969,0-9.213,3.776-9.213,17.11V41.3a1.78,1.78,0,0,0,1.78,1.78h36.8a1.78,1.78,0,0,0,1.78-1.78V19.812C382.655,6.074,379.865,0,373.809,0c-8.2,0-10.239,13.35-11.476,14.82",
    transform: "translate(-265.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_721",
    "data-name": "Trazado 721",
    d: "M189.532,12.048H172.925a1.78,1.78,0,0,0-1.78,1.78v36.8a1.78,1.78,0,0,0,1.78,1.78h14.619a1.78,1.78,0,0,0,1.774-1.928l-.592-7.135a1.39,1.39,0,0,1,1.075-1.707c4.824-1.284,18.571-4.232,16.98-17.3-.94-7.723-6.331-12.292-17.25-12.292",
    transform: "translate(-132.587 -9.334)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_722",
    "data-name": "Trazado 722",
    d: "M26.449,27.032c-1.154-.6-1.168-1.333-.479-1.944,1.362-1.208,4.679-3.5,4.247-7.054-.53-4.363-4.255-5.985-11.883-5.985H1.78A1.78,1.78,0,0,0,0,13.828V50.633a1.78,1.78,0,0,0,1.78,1.78H18.387c10.919,0,16.456-4.553,17.25-12.292.762-7.426-4.23-10.5-9.188-13.089",
    transform: "translate(0 -9.334)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBpmSpecial);
export default __webpack_public_path__ + "static/media/BPMSpecial.c0ee2d6cea8eabb3e2fb4dede502ae22.svg";
export { ForwardRef as ReactComponent };